import cx from 'classnames';
import React from 'react';

import s from './HeaderContainer.scss';
import { MobileControls } from './MobileControls';
import { Heading, Text } from 'wix-style-react';

class HeaderContainer extends React.Component {
  render() {
    const { onIndustryChange, onBusinessIdeaChange, t, businessIdea, industry, sticky, onSearchNames, industriesFetcher } = this.props;
    const title = t('BNG_NAMES_LIST_HEADER_TITLE');
    const subtitle = t('MOBILE_BNG_NAMES_LIST_TITLE');

    return (
      <div className={cx(s.headerContainerMobile, { [s.sticky]: sticky })}>
        <div className={cx(s.wixLogoContainer, s.logoContainer)}>
          <div className={s.wixLogo} />
        </div>
        <div className={cx(s.title, { [s.sticky]: sticky })}>
          <Heading appearance="H2">{title}</Heading>
        </div>
        <div className={cx(s.subtitle, { [s.sticky]: sticky })}>
          <Text secondary>{subtitle}</Text>
        </div>
        <div className={cx(s.controls, { [s.sticky]: sticky })}>
          <MobileControls
            t={t}
            businessIdea={businessIdea}
            onBusinessIdeaChange={onBusinessIdeaChange}
            onIndustryChange={onIndustryChange}
            onSearch={onSearchNames}
            industry={industry}
            industriesFetcher={industriesFetcher}
          />
        </div>
      </div>
    );
  }
}

export default HeaderContainer;
